<!--
 * @Auther: liuguangsheng1
 * @Date: 2021-08-19 18:10:12
 * @LastEditTime: 2022-02-21 15:34:07
 * @Description:
-->

<template>
    <div class="side-menu">
        <div
            @click="togleMenu(menu)"
            :class="
                menu.code === currentValue
                    ? 'side-menu-item selected'
                    : 'side-menu-item'
            "
            v-for="menu in subMenuData"
            :key="menu.code"
        >
            <div class="side-menu-item-icon">
                <img
                    :src="menu.img ? `${'https://' + menu.img}` : defaultIcon"
                />
            </div>
            <div class="side-menu-item-text">{{ menu.name }}</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MDLogMenu } from '@/api/menu'
import defaultIcon from '../assets/menu-icon.svg'
export default {
    name: 'sideMenu',
    props: {},
    data() {
        return {
            currentValue: '',
            defaultIcon,
            // menuData: [
            //     {
            //         name: '菜单管理',
            //         id: 1,
            //     },
            //     {
            //         name: '角色管理',
            //         id: 2,
            //     },
            //     {
            //         name: '硬件管理',
            //         id: 3,
            //     },
            //     {
            //         name: '收银员管理',
            //         id: 4,
            //     },
            //     {
            //         name: '部门管理',
            //         id: 5,
            //     },
            // ],
        }
    },
    computed: {
        ...mapGetters({
            subMenuData: 'subMenuData',
            selectedSubMenu: 'selectedSubMenu',
        }),
    },
    methods: {
        togleMenu(item) {
            console.log('togleMenu')
            console.log(item)
            MDLogMenu(
                { resourceType: 1 },
                'JDmall_md',
                'menu_md',
                item.code,
                item.name,
                item.url
            )
            let selectedMenu = this.getMenu(item.code)
            this.$store.dispatch('app/setSelectedSubMenu', selectedMenu)
            window.clickUrl = selectedMenu.activeLinkUrl
            history.pushState(
                null,
                `${selectedMenu.activeLinkUrl}`,
                `${selectedMenu.activeLinkUrl}`
            )
            console.log(selectedMenu)
        },
        getMenu(index) {
            console.log(index)
            let selectedMenu = {}
            let microData = this.$store.getters.microData
            microData.forEach((item) => {
                if (item.id === index) {
                    selectedMenu = item
                }
            })
            return selectedMenu
        },
    },
    watch: {
        selectedSubMenu(val) {
            console.log(val)
            this.currentValue = val.id
        },
    },
}
</script>

<style lang="scss" scoped>
.side-menu {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    &-item {
        margin-top: 24px;
        margin-left: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: normal;
        color: rgba(26, 26, 26, 1);
        cursor: pointer;
        &-icon {
            margin-right: 8px;
            margin-top: 1px;
            width: 16px;
            height: 16px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        &-text {
            height: 16px;
            line-height: 16px;
        }
        &:nth-child(1) {
            margin-top: 16px;
        }
    }

    .selected {
        color: red;
        font-weight: bold;
    }
}
</style>
